import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { useGlobalContext } from "../Config";
import { jsPDF } from "jspdf";
import { Dialog } from "primereact/dialog";
import "jspdf-autotable";
import { ProgressSpinner } from "primereact/progressspinner";
import moment from "moment-timezone";
import {
  generateNotaDeCobroPDF,
  generateEstadoDeCuentaPDF,
} from "../utilities/pdfGenerator";
import JSZip from "jszip";
import * as XLSX from "xlsx";
import { formatDate, formatRut } from "../utilities/displayFormat";

const Estados = (props) => {
  const { baseUrl } = useGlobalContext();
  const { headerText } = useGlobalContext();
  const [loading, setLoading] = useState(true);
  const { styleProperties } = useGlobalContext();
  const [empresa, setEmpresa] = useState(null);
  const [empresas, setEmpresas] = useState([]);
  const [anio, setAnio] = useState(moment().year());
  const [mes, setMes] = useState(moment().format("MM"));
  const [isLoading, setIsLoading] = useState(false);
  const [documentosData, setDocumentosData] = useState([]); // Estado para los documentos
  const [show1, setShow1] = useState(false);
  const [visibleDialog, setVisibleDialog] = useState(false); // Controla la visibilidad del dialog
  const [selectedDocument, setSelectedDocument] = useState(null); // Controla el documento seleccionado para mostrar en el dialog
  const [expandedRows, setExpandedRows] = useState(null); // Controla las filas expandidas

  const userId = sessionStorage.getItem("userId");

  const currentYear = new Date().getFullYear();
  const anios = Array.from({ length: currentYear - 2020 + 5 }, (_, i) => ({
    label: String(2020 + i),
    value: 2020 + i,
  }));
  const meses = Array.from({ length: 12 }, (_, i) => {
    const date = new Date(0, i); // Set date to month `i`
    return {
      label:
        date.toLocaleString("es", { month: "long" }).charAt(0).toUpperCase() +
        date.toLocaleString("es", { month: "long" }).slice(1),
      mes: String(i + 1).padStart(2, "0"), // Month number with leading zero
    };
  });

  const formatNumber = (number) => {
    if (typeof number !== "number") return number;
    return new Intl.NumberFormat("es-CL", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(number);
  };

  const formatNumberUf = (number) => {
    if (typeof number !== "number") return number;
    return new Intl.NumberFormat("es-CL", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(number);
  };

  ///////////////////////////////////////////////////////// Fetchs /////////////////////////////////////////////////////////
  useEffect(() => {
    const fetchEmpresas = async () => {
      const endpoint = `${baseUrl}getEmpresasByUsuario?idUsuario=${userId}`;
      try {
        const response = await fetch(endpoint, {
          method: "GET",
          credentials: "include",
          redirect: "follow",
        });
        const data = await response.json();
        if (data.respuesta) {
          const empresasReales = data.empresas
            .filter(
              (item) =>
                !String(item.razonSocial || item.nombre || "")
                  .toLowerCase()
                  .includes("prueba"),
            )
            .map((item) => ({
              label: item.razonSocial || item.nombre || `Empresa ${item.id}`,
              id: item.id,
            }));
          setEmpresas([
            { label: "Todas las empresas", id: "TODAS" },
            ...empresasReales,
          ]);
          setEmpresa("TODAS");
        }
      } catch (error) {
        console.error("Error fetching empresas:", error);
      }
    };
    fetchEmpresas();
  }, [baseUrl, userId]);

  // Fetch grupos al presionar "Buscar"
  const handleBuscar = async () => {
    setIsLoading(true);
    try {
      setShow1(true);
      const idsEmpresa =
        empresa === "TODAS"
          ? empresas
              .filter((item) => item.id !== "TODAS")
              .map((item) => item.id)
          : [empresa];
      const respuestas = await Promise.all(
        idsEmpresa.map(async (idEmpresa) => {
          const endpointGrupos = `${baseUrl}obtenerGrupos?idEmpresa=${idEmpresa}&anio=${anio}&mes=${mes}`;
          const responseGrupos = await fetch(endpointGrupos, {
            method: "GET",
            credentials: "include",
            redirect: "follow",
          });
          const dataGrupos = await responseGrupos.json();
          return dataGrupos.respuesta && Array.isArray(dataGrupos.grupos)
            ? dataGrupos.grupos
            : [];
        }),
      );
      setDocumentosData(respuestas.flat());
    } catch (error) {
      console.error("Error al buscar datos: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  const showDocumentDetails = (rowData) => {
    const docs = Array.isArray(rowData?.documentos) ? rowData.documentos : [];
    setSelectedDocument(docs);
    setExpandedRows(docs);
    setVisibleDialog(true);
  };

  const actionTemplate = (rowData) => {
    return (
      <div className="actions">
        <Button
          icon="pi pi-info"
          className="p-button-rounded p-button-info"
          onClick={() => showDocumentDetails(rowData)}
        />
        <Button
          icon="pi pi-file-pdf"
          className="p-button-rounded p-button-warning"
          onClick={() => exportToPDF(rowData)}
          style={{ marginLeft: "5px" }}
        />
        <Button
          icon="pi pi-download"
          className="p-button-rounded p-button-success"
          onClick={() => handleDownloadZip(rowData)}
          style={{ marginLeft: "5px" }}
        />
      </div>
    );
  };

  const handleDownloadZip = async (grupo) => {
    const zip = new JSZip();

    // 1. Validar que todos los documentos requeridos tengan adjuntos
    const facturasRequeridas = grupo.documentos.filter(
      (doc) =>
        doc.tipoDocumento.toLowerCase() === "factura afecta" ||
        doc.tipoDocumento.toLowerCase() === "factura exenta",
    );

    const faltantes = facturasRequeridas.filter(
      (doc) => !doc.adjuntos || doc.adjuntos.length === 0,
    );

    console.log("aaa: ", facturasRequeridas);

    if (faltantes.length > 0) {
      alert(
        "No se puede descargar el archivo. Falta(n) la(s) factura(s) asociada(s) a los siguientes documentos:\n" +
          faltantes
            .map((doc) => `Documento N°: ${doc.idDocumento || "N/A"}`)
            .join("\n"),
      );
      return;
    }

    // 2. Generar PDFs existentes
    const notaDeCobro = grupo.documentos.find(
      (doc) => doc.tipoDocumento.toLowerCase() === "nota de cobro",
    );
    if (notaDeCobro) {
      const notaBlob = generateNotaDeCobroPDF(
        baseUrl,
        notaDeCobro,
        formatNumber,
        formatNumberUf,
        formatDate,
        grupo.mes,
        grupo.anio,
      );
      zip.file(`NotaDeCobro_${notaDeCobro.folio || "sin_folio"}.pdf`, notaBlob);
    }

    const estadoBlob = generateEstadoDeCuentaPDF(
      baseUrl,
      grupo,
      formatNumber,
      formatNumberUf,
      formatDate,
      grupo.mes,
      grupo.anio,
    );
    zip.file(
      `EstadoDeCuenta_${grupo.numeroEstado || "sin_numero"}.pdf`,
      estadoBlob,
    );

    // 3. Descargar los adjuntos y agregarlos al ZIP
    for (const documento of facturasRequeridas) {
      for (const adjunto of documento.adjuntos) {
        try {
          const response = await fetch(
            `${baseUrl}descargar/adjunto/documento?id=${documento.idDocumento}`,
            {
              method: "GET",
              credentials: "include",
              redirect: "follow",
              headers: { "Content-Type": "application/json" },
            },
          );
          if (!response.ok) {
            throw new Error(`Error descargando archivo ${adjunto.nombre}`);
          }

          const blob = await response.blob();
          zip.file(adjunto.nombre, blob);
        } catch (error) {
          console.error(
            `Error descargando archivo adjunto: ${adjunto.nombre}`,
            error,
          );
        }
      }
    }

    // 4. Generar el ZIP y descargarlo
    const zipBlob = await zip.generateAsync({ type: "blob" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(zipBlob);
    link.download = `Documentos_${grupo.nombreCliente || "cliente"}_${
      grupo.descripcionGrupo || "documentos"
    }.zip`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  };

  // Plantilla de expansión de fila para mostrar los detalles de cobro
  const rowExpansionTemplate = (data) => (
    <DataTable value={data.detallesCobro} responsiveLayout="scroll">
      <Column field="glosa" header="Descripción" />
      <Column field="unidadMedida" header="Unidad de Medida" />
      <Column field="cantidad" header="Cantidad" />
      <Column
        field="unitario"
        header="Precio Unitario"
        body={(rowData) => formatNumber(rowData.unitario)}
      />
    </DataTable>
  );

  const toggleRowExpansion = (rowData) => {
    setExpandedRows((prevExpandedRows) => {
      const expanded = prevExpandedRows ? [...prevExpandedRows] : [];
      const index = expanded.findIndex(
        (row) => row.idDocumento === rowData.idDocumento,
      );
      if (index >= 0) {
        expanded.splice(index, 1); // Cierra la fila si ya está expandida
      } else {
        expanded.push(rowData); // Expande la fila si está cerrada
      }
      return expanded;
    });
  };

  const expandButtonTemplate = (rowData) => (
    <Button
      icon={
        expandedRows?.find((row) => row.idDocumento === rowData.idDocumento)
          ? "pi pi-angle-up"
          : "pi pi-angle-down"
      }
      className="p-button-rounded p-button-text"
      onClick={() => toggleRowExpansion(rowData)}
    />
  );

  ///////////////////////////////////////////////////////// GENERAR PDFs /////////////////////////////////////////////////////////

  const exportToPDF = (rowData) => {
    const estadoBlob = generateEstadoDeCuentaPDF(
      baseUrl,
      rowData,
      formatNumber,
      formatNumberUf,
      formatDate,
      mes,
      anio,
    );
    const pdfUrl = URL.createObjectURL(estadoBlob);
    window.open(pdfUrl, "_blank");
    setTimeout(() => URL.revokeObjectURL(pdfUrl), 60000);
  };

  const [globalFilter, setGlobalFilter] = useState("");

  const calcularTotalIVA = (total, tipoDocumento) =>
    tipoDocumento.toLowerCase() === "factura afecta" ? total * 1.19 : total;

  // Template for Factura Afecta column
  const facturaAfectaTemplate = (rowData) => {
    const facturasAfectas = rowData.documentos.filter(
      (doc) => doc.tipoDocumento.toLowerCase() === "factura afecta",
    );

    if (facturasAfectas.length > 0) {
      const totalSinIVA = facturasAfectas.reduce(
        (sum, doc) => sum + doc.total,
        0,
      );
      const totalConIVA = totalSinIVA * 1.19;

      return (
        <span>
          {totalConIVA.toLocaleString("es-CL", {
            style: "currency",
            currency: "CLP",
          })}
        </span>
      );
    }
    return "-";
  };

  // Template for Factura Exenta column
  const facturaExentaTemplate = (rowData) => {
    const facturasExentas = rowData.documentos.filter(
      (doc) => doc.tipoDocumento.toLowerCase() === "factura exenta",
    );

    if (facturasExentas.length > 0) {
      const total = facturasExentas.reduce((sum, doc) => sum + doc.total, 0);

      return (
        <span>
          {total.toLocaleString("es-CL", {
            style: "currency",
            currency: "CLP",
          })}
        </span>
      );
    }
    return "-";
  };

  // Template for Nota de Venta column
  const notaVentaTemplate = (rowData) => {
    const notasVenta = rowData.documentos.filter(
      (doc) => doc.tipoDocumento.toLowerCase() === "nota de cobro",
    );

    if (notasVenta.length > 0) {
      const total = notasVenta.reduce((sum, doc) => sum + doc.total, 0);

      return (
        <span>
          {total.toLocaleString("es-CL", {
            style: "currency",
            currency: "CLP",
          })}
        </span>
      );
    }
    return "-";
  };

  const documentos = (rowData) =>
    Array.isArray(rowData?.documentos) ? rowData.documentos : [];
  const detalles = (rowData) =>
    documentos(rowData).flatMap((doc) =>
      Array.isArray(doc.detallesCobro) ? doc.detallesCobro : [],
    );
  const productosTemplate = (rowData) => {
    const productos = [
      ...new Set(
        detalles(rowData)
          .map((d) => d.glosa)
          .filter(Boolean),
      ),
    ];
    if (!productos.length) return "-";
    return productos.length <= 2
      ? productos.join(", ")
      : `${productos.slice(0, 2).join(", ")} +${productos.length - 2}`;
  };
  const empresaTemplate = (rowData) => {
    const empresasGrupo = [
      ...new Set(
        documentos(rowData)
          .map((d) => d.descripcionEmpresa)
          .filter(Boolean),
      ),
    ];
    return empresasGrupo.length ? empresasGrupo.join(", ") : "-";
  };
  const fechaAsignacionTemplate = (rowData, campo) =>
    rowData?.[campo] ? formatDate(rowData[campo]) : "-";
  const numeroDocumentoDisponible = (folio) => {
    if (folio === null || folio === undefined || folio === "") return null;
    const numero = Number(folio);
    if (!Number.isFinite(numero) || numero <= 0) return null;
    return String(Math.trunc(numero));
  };
  const numerosDocumentoTexto = (rowData) => {
    const docs = documentos(rowData);
    if (!docs.length) return "No disponibles";

    const valores = docs.map((doc) => numeroDocumentoDisponible(doc.folio));
    const disponibles = valores.filter(Boolean);
    const faltantes = valores.length - disponibles.length;

    if (!disponibles.length) return "No disponibles";
    return `${disponibles.join(", ")}${
      faltantes > 0 ? ", No disponibles" : ""
    }`;
  };
  const numerosDocumentoTemplate = (rowData) => numerosDocumentoTexto(rowData);
  const numeroDocumentoDetalleTemplate = (rowData) => {
    const folio = numeroDocumentoDisponible(rowData?.folio);
    return folio || "N° documento no disponible";
  };
  const fechasDocumentoTemplate = (rowData, campo) => {
    const fechas = [
      ...new Set(
        documentos(rowData)
          .map((d) => d[campo])
          .filter(Boolean)
          .map(formatDate),
      ),
    ];
    return fechas.length ? fechas.join(", ") : "-";
  };
  const descuentosValor = (rowData) =>
    detalles(rowData)
      .filter(
        (d) =>
          String(d.glosa || "")
            .toLowerCase()
            .includes("descuento") || Number(d.unitario) < 0,
      )
      .reduce(
        (sum, d) =>
          sum + Math.abs(Number(d.unitario || 0) * Number(d.cantidad || 1)),
        0,
      );
  const descuentosTemplate = (rowData) => {
    const total = descuentosValor(rowData);
    return total ? `$ ${formatNumber(total)}` : "$ 0";
  };

  const textoBusqueda = globalFilter.trim().toLowerCase();
  const estadosFiltrados = documentosData.filter((row) => {
    if (!textoBusqueda) return true;
    const cliente = String(
      row.aliasCliente || row.nombreCliente || "",
    ).toLowerCase();
    const productos = detalles(row)
      .map((d) => String(d.glosa || "").toLowerCase())
      .join(" ");
    return cliente.includes(textoBusqueda) || productos.includes(textoBusqueda);
  });

  ///////////////// exportar a excel /////////////////

  const exportTableToExcel = () => {
    if (!estadosFiltrados || estadosFiltrados.length === 0) {
      alert("No hay datos para exportar.");
      return;
    }

    const dataToExport = estadosFiltrados.map((row) => {
      const facturasAfectas = row.documentos.filter(
        (doc) => doc.tipoDocumento.toLowerCase() === "factura afecta",
      );
      const facturasExentas = row.documentos.filter(
        (doc) => doc.tipoDocumento.toLowerCase() === "factura exenta",
      );
      const notasCobro = row.documentos.filter(
        (doc) => doc.tipoDocumento.toLowerCase() === "nota de cobro",
      );

      const totalFacturaAfectaSinIVA = facturasAfectas.reduce(
        (sum, doc) => sum + doc.total,
        0,
      );
      const totalFacturaAfectaConIVA = totalFacturaAfectaSinIVA * 1.19;

      const totalFacturaExenta = facturasExentas.reduce(
        (sum, doc) => sum + doc.total,
        0,
      );

      const totalNotaCobro = notasCobro.reduce(
        (sum, doc) => sum + doc.total,
        0,
      );

      return {
        Empresa: empresaTemplate(row),
        "Alias Cliente": row.aliasCliente || row.nombreCliente || "",
        Producto: [
          ...new Set(
            detalles(row)
              .map((d) => d.glosa)
              .filter(Boolean),
          ),
        ].join(", "),
        Asignación: row.descripcionGrupo,
        "N° Documentos": numerosDocumentoTexto(row),
        "Fecha Documentos": fechasDocumentoTemplate(row, "fechaEmision"),
        "Fecha Vencimiento": fechasDocumentoTemplate(row, "fechaVencimiento"),
        "Cantidad de Documentos": documentos(row).length,
        "Factura Afecta": totalFacturaAfectaConIVA,
        "Factura Exenta": totalFacturaExenta,
        "Nota de Cobro": totalNotaCobro,
        Descuentos: descuentosValor(row),
        "Deuda Pendiente": row.deudaCobranzas || 0,
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(dataToExport, { origin: "A2" });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "EstadosDeCuenta");

    XLSX.utils.sheet_add_aoa(
      worksheet,
      [[`Estados de cuenta del periodo ${mes}-${anio}`], []],
      { origin: "A1" },
    );

    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let R = 2; R <= range.e.r; ++R) {
      ["F", "G", "H"].forEach((col) => {
        const cell = worksheet[`${col}${R + 1}`]; // +1 por el encabezado
        if (cell && typeof cell.v === "number") {
          cell.z = '"$"#,##0';
        }
      });
    }

    worksheet["!cols"] = [
      { wch: 30 }, // CLIENTE
      { wch: 15 }, // asignacion
      { wch: 10 }, // RUT CLIENTE
      { wch: 20 }, // INICIO PAGO
      { wch: 20 }, // FIN PAGO
      { wch: 18 }, // F. AFECTA
      { wch: 18 }, // F. EXENTE
      { wch: 18 }, // NOTA DE COBRO
    ];

    const mesLabel = meses.find((m) => m.mes === mes)?.label || mes;
    const fileName = `EstadoDeCuenta${mesLabel}-${anio}.xlsx`;

    XLSX.writeFile(workbook, fileName);
  };

  return (
    <div>
      <h3>Estados de cuenta</h3>
      <small>Aqui podrá revisar el estado de cuenta mensual por contrato</small>
      <div
        className="flex flex-column align-items-center justify-content-center mb-5 bg-surface-50"
        style={{ marginTop: "20px" }}
      >
        <div className="card shadow-4 surface-card border-round-md w-full max-w-lg">
          <h4 className="text-center text-primary mb-4">
            Seleccione la información deseada
          </h4>

          <div className="grid formgrid">
            <div className="field col-12 md:col-4 mb-4">
              <label
                htmlFor="empresa"
                className="block font-semibold mb-1 text-gray-600"
              >
                Empresa
              </label>
              <Dropdown
                inputId="empresa"
                aria-label="Seleccionar empresa"
                value={empresa}
                options={empresas.map((option) => ({
                  ...option,
                  label: option.label.toUpperCase(),
                }))}
                onChange={(e) => setEmpresa(e.value)}
                optionLabel="label"
                optionValue="id"
                placeholder="Seleccione Empresa"
                className="w-full p-2 border border-gray-300 rounded"
              />
            </div>

            <div className="field col-12 md:col-4 mb-4">
              <label
                htmlFor="anio"
                className="block font-semibold mb-1 text-gray-600"
              >
                Año
              </label>
              <Dropdown
                inputId="anio"
                aria-label="Seleccionar año"
                value={anio}
                options={anios.map((option) => ({
                  ...option,
                  label: option.label.toUpperCase(),
                }))}
                onChange={(e) => setAnio(e.value)}
                placeholder="Seleccione Año"
                className="w-full p-2 border border-gray-300 rounded"
              />
            </div>

            <div className="field col-12 md:col-4 mb-4">
              <label
                htmlFor="mes"
                className="block font-semibold mb-1 text-gray-600"
              >
                Mes
              </label>
              <Dropdown
                inputId="mes"
                aria-label="Seleccionar mes"
                value={mes}
                options={meses.map((option) => ({
                  ...option,
                  label: option.label.toUpperCase(),
                }))}
                onChange={(e) => setMes(e.value)}
                optionLabel="label"
                optionValue="mes"
                placeholder="Seleccione Mes"
                className="w-full p-2 border border-gray-300 rounded"
              />
            </div>
          </div>

          <div className="text-center mt-4">
            <Button
              label="Buscar"
              aria-label="Buscar"
              icon="pi pi-search"
              onClick={handleBuscar}
              className="p-button-raised p-button-primary w-full md:w-auto px-6 py-2 text-lg font-medium shadow-lg transition duration-150 ease-in-out"
            />
          </div>
        </div>
      </div>
      {show1 && (
        <>
          <style>
            {`
        /* Wrapper for rounded table shape */
        .table-wrapper {
          border-radius: 0.5rem;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          background-color: #ffffff;
        }

        /* Table Styling */
        .p-datatable {
          border: none;
          border-radius: 0.5rem;
        }
        .p-datatable .p-datatable-thead > tr > th {
          background-color: #e3f2fd; /* Light blue header */
          font-weight: 600;
          text-align: center;
          border-bottom: none;
        }

        .p-datatable .p-datatable-tbody > tr {
          transition: background-color 0.2s ease;
        }

        /* Row hover effect */
        .p-datatable .p-datatable-tbody > tr:hover {
          background-color: #f1f5f9;
        }

        /* Alternate row colors */
        .p-datatable .p-datatable-tbody > tr:nth-child(odd) {
          background-color: #ffffff;
        }
        .p-datatable .p-datatable-tbody > tr:nth-child(even) {
          background-color: #f9fafb;
        }

        /* Centering text */
        .p-datatable .p-column-header-content {
          justify-content: center;
        }

        /* Table cell padding and rounding */
        .p-datatable .p-datatable-tbody > tr > td {
          padding: 1rem;
          border-radius: 0.25rem;
        }

        /* Action Column Icons */
        .action-icons {
          display: flex;
          gap: 0.5rem;
        }

        /* Icon Styling */
        .icon {
          font-size: 1.5rem;
          color: #007bff;
          cursor: pointer;
          transition: color 0.2s ease;
        }
        .icon:hover {
          color: #0056b3; /* Darker blue on hover */
        }

        /* Responsive */
        .table-wrapper {
          overflow-x: auto;
        }

        /* Custom loading spinner */
        .custom-spinner {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          width: 100%;
          font-size: 2rem;
          color: #007bff;
        }
      `}
          </style>
          <div
            style={{
              display: "flex",
              gap: "1rem",
              alignItems: "stretch",
              flexWrap: "wrap",
              marginBottom: "1rem",
            }}
          >
            <InputText
              placeholder="Buscar por cliente o producto"
              value={globalFilter}
              onChange={(e) => setGlobalFilter(e.target.value)}
              style={{
                borderRadius: "0.5rem",
                padding: "0.75rem 1rem",
                boxShadow: "0 2px 8px rgba(0, 123, 255, 0.2)",
                fontSize: "1rem",
                flex: "1",
                maxWidth: "200px",
                height: "42px",
              }}
            />

            <Button
              style={{
                borderRadius: "0.5rem",
                padding: "0.75rem 1rem",
                boxShadow: "0 2px 8px rgba(0, 123, 255, 0.2)",
                fontSize: "1rem",
                flex: "1",
                maxWidth: "150px",
                height: "42px",
              }}
              label="Exportar a Excel"
              icon="pi pi-file-excel"
              className="p-button-success"
              onClick={exportTableToExcel}
            />
          </div>
          <div style={{ marginBottom: "1rem", fontWeight: 600 }}>
            Total estados de cuenta: {estadosFiltrados.length} &nbsp;|&nbsp;
            Total documentos:{" "}
            {estadosFiltrados.reduce(
              (total, estado) =>
                total +
                (Array.isArray(estado.documentos)
                  ? estado.documentos.length
                  : 0),
              0,
            )}
          </div>
          <DataTable
            className="p-datatable-gridlines"
            value={estadosFiltrados}
            style={{ marginTop: "20px" }}
            loading={isLoading}
            rows={40}
            rowsPerPageOptions={[5, 10, 20, 50]}
            paginator
            emptyMessage="No se encontraron estados de cuenta"
            scrollable
            scrollHeight="750px" // Define un alto para que se active el scroll
            scrollDirection="vertical" // Habilita scroll vertical
          >
            <Column header="Empresa" body={empresaTemplate} />
            <Column
              field="aliasCliente"
              header="Alias Cliente"
              sortable
              body={(rowData) =>
                rowData.aliasCliente || rowData.nombreCliente || "-"
              }
            />
            <Column header="Producto" body={productosTemplate} />
            <Column field="descripcionGrupo" header="Asignación" sortable />
            <Column header="N° Documentos" body={numerosDocumentoTemplate} />
            <Column
              header="Fecha Documentos"
              body={(rowData) =>
                fechasDocumentoTemplate(rowData, "fechaEmision")
              }
            />
            <Column
              header="Fecha Vencimiento"
              body={(rowData) =>
                fechasDocumentoTemplate(rowData, "fechaVencimiento")
              }
            />
            <Column
              header="Cantidad de Documentos"
              body={(rowData) => documentos(rowData).length}
            />
            <Column header="Factura Afecta" body={facturaAfectaTemplate} />
            <Column header="Factura Exenta" body={facturaExentaTemplate} />
            <Column header="Nota de Cobro" body={notaVentaTemplate} />
            <Column header="Descuentos" body={descuentosTemplate} />
            <Column
              header="Deuda Pendiente"
              field="deudaCobranzas"
              body={(rowData) =>
                rowData.deudaCobranzas
                  ? `$ ${formatNumber(rowData.deudaCobranzas)}`
                  : "$ 0"
              }
              sortable
            />
            <Column header="Acciones" body={actionTemplate} />
          </DataTable>
        </>
      )}
      <Dialog
        header="Documentos asociados"
        visible={visibleDialog}
        style={{ width: "95vw" }}
        modal
        onHide={() => setVisibleDialog(false)}
      >
        {selectedDocument && (
          <DataTable
            className="p-datatable-gridlines"
            value={selectedDocument}
            expandedRows={expandedRows}
            onRowToggle={(e) => setExpandedRows(e.data)}
            rowExpansionTemplate={rowExpansionTemplate}
            dataKey="idDocumento"
            emptyMessage="No se encontraron detalles para este estado de cuenta"
          >
            <Column
              field="folio"
              header="N° Documento"
              body={numeroDocumentoDetalleTemplate}
              style={{ textAlign: "center" }}
            />
            <Column
              field="tipoDocumento"
              header="Tipo Documento"
              style={{ textAlign: "center" }}
            />
            <Column
              field="total"
              header="Total"
              body={(rowData) => formatNumber(rowData.total)}
              style={{ textAlign: "center" }}
            />
            <Column
              header="Ver Detalle"
              body={expandButtonTemplate}
              style={{ textAlign: "center", width: "3em" }}
            />
          </DataTable>
        )}
      </Dialog>
    </div>
  );
};

export default Estados;
